<div class="container">
  <div class="previsao-orcamentaria">
    <h1>Previsão Orçamentária</h1>
    <div class="subtitulo">
      <div>
        <h2>
          <a routerLink="/pqr">
            Conheça os parâmetros de qualidade de refêrencia para essa simulação
          </a>
        </h2>
        <h2>
          <a href="../../../assets/SIMCAQ_MEMORIA_CALCULO.pdf" target="_blank">
            Memória de Cálculo
          </a>
        </h2>
      </div>
      <div class="editar">
        <a routerLink="/relatorio2/acesso-oferta-educacional/diagnostico-matricula">
          <button
            mat-button
            class="botao-editar"
            title="Edite os resultados apresentados alterando os padrões
                  de qualidade de referência">
            <mat-icon>edit_square</mat-icon>
            Editar resultado
          </button>
        </a>
      </div>
    </div>
  </div>

  <div class="table-content">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" style="width: 15%">Dimensão da oferta</th>
          <th class="table-header" style="width: 20%">Atual</th>
          <th class="table-header" style="width: 50%">Projeção</th>
          <th class="table-header" style="width: 15%">
            Variação Atual-Projeção <sup>(1)</sup>
          </th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <ng-container *ngIf="dadosEstatisticos && memoriaDeCalculo">
          <tr>
            <td>Número de matrículas</td>
            <td>
              {{
                dadosEstatisticos.totalMatriculas.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.total?.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                porcentagemDoValor(
                  calcularVariacao(
                    memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.total ?? 0,
                    dadosEstatisticos.totalMatriculas
                  ),
                  memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.total ?? 0
                )
              }}
            </td>
          </tr>
          <tr>
            <td>Número de turmas</td>
            <td>
              {{
                dadosEstatisticos.totalTurmas.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                (
                  featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade') && memoriaDeCalculo.resultadoCalcNumTurmas
                    ? memoriaDeCalculo.resultadoCalcNumTurmas.total
                    : memoriaDeCalculo.resultadoEtapa4CalculoNumeroTurmas?.total
                )?.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                porcentagemDoValor(
                  calcularVariacao(
                    (
                      featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade') && memoriaDeCalculo.resultadoCalcNumTurmas
                        ? memoriaDeCalculo.resultadoCalcNumTurmas.total
                        : memoriaDeCalculo.resultadoEtapa4CalculoNumeroTurmas?.total
                    ) ?? 0,
                    dadosEstatisticos.totalTurmas
                  ),
                  (
                    featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade') && memoriaDeCalculo.resultadoCalcNumTurmas
                      ? memoriaDeCalculo.resultadoCalcNumTurmas.total
                      : memoriaDeCalculo.resultadoEtapa4CalculoNumeroTurmas?.total
                  ) ?? 0
                )
              }}
            </td>
          </tr>
          <tr>
            <td>Número de professores</td>
            <td>
              {{
                dadosEstatisticos.totalProfessores.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                ((featureFlagService.funcionalidadeHabilitada('1104-creche-idade')
                  ? memoriaDeCalculo.resultadoCalcNumProf?.total
                  : memoriaDeCalculo.resultadoEtapa10CalculoDemandaPorDocentes?.total) ?? 0)
                  .toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                porcentagemDoValor(
                  calcularVariacao(
                    (featureFlagService.funcionalidadeHabilitada('1104-creche-idade')
                      ? memoriaDeCalculo.resultadoCalcNumProf?.total
                      : memoriaDeCalculo.resultadoEtapa10CalculoDemandaPorDocentes?.total) ?? 0,
                    dadosEstatisticos.totalProfessores
                  ),
                  (featureFlagService.funcionalidadeHabilitada('1104-creche-idade')
                    ? memoriaDeCalculo.resultadoCalcNumProf?.total
                    : memoriaDeCalculo.resultadoEtapa10CalculoDemandaPorDocentes?.total) ?? 0
                )
              }}
            </td>
          </tr>
          <tr>
            <td>Número de auxiliares</td>
            <td>
              {{
                dadosEstatisticos.totalAuxiliares.toLocaleString('pt-BR')
              }}
            </td>
            <td>-</td>
            <td>-</td>
          </tr>
          <tr>
            <td>Número de funcionários</td>
            <td>
              {{
                dadosEstatisticos.totalFuncionarios.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total.toLocaleString('pt-BR')
              }}
            </td>
            <td>
              {{
                porcentagemDoValor(
                  calcularVariacao(
                    memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total,
                    dadosEstatisticos.totalFuncionarios
                  ),
                  memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total
                )
              }}
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </app-tabela>
    <div class="notas">
      <small>
        <em>
          <p>Notas:</p>
          <p>
            <sup>(1)</sup>
            Variação de valores entre o diagnóstico e o projetado.
          </p>
          <p>
            <sup>(2)</sup>
            O resultado da projeção do número de professores necessários depende
            do padrão de jornada de trabalho semanal adotado.Inicialmente, o
            simulador faz projeções considerando uma jornada de 40 horas
            semanais. Se necessário, edite o resultado e altere esse parâmetro
            de modo a expressar a jornada dos docentes da rede em análise.
          </p>
        </em>
      </small>
    </div>
    <div class="download-csv">
      <button mat-button color="primary">
        <mat-icon>table_chart</mat-icon>
        Download CSV
      </button>
    </div>
  </div>
  <div class="table-content">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2" style="width: 15%">
            Esfera Administrativa
          </th>
           <th class="table-header" style="width: 10%">
             Receita Potencial mínima Vinculada à Educação (R$) <sup>(3)</sup>
           </th>
          <th class="table-header" style="width: 10%">
            Despesa realizada com Educação Básica (R$) <sup>(4)</sup>
          </th>
          <th class="table-header" style="width: 50%">
            {{ mostrarRpebAposVaat ? 'Projeção Orçamento da despesa CAQ - (R$)' : 'Projeção da despesa necessária (R$)' }}
          </th>
          <th class="table-header" rowspan="2" style="width: 10%">
            Complementação (R$) 2022-2024 <sup>(5)</sup>
          </th>
          <th class="table-header" rowspan="2" style="width: 10%">
            Complementação (%) 2022-2024 <sup>(6)</sup>
          </th>
        </tr>
        <tr>
          <th class="table-header">2022</th>
          <th class="table-header">2022</th>
          <th class="table-header">2024</th>
        </tr>
      </ng-container>
      <ng-container corpo *ngIf="dadosFinanceiros && memoriaDeCalculo">
        <tr class="large">
          <td>Governo Municipal</td>
          <td>
            {{ formatarDinheiro(dadosFinanceiros[1].vlrDadoFinanceiro) }}
          </td>
          <td>
            {{ formatarDinheiro(dadosFinanceiros[0].vlrDadoFinanceiro) }}
          </td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoDespesaPessoalManutencao?.despesasGovernoMunicipal ?? 0) }}
          </td>
          <td>
            {{
              formatarDinheiro(
                calcularComplementacao(
                  memoriaDeCalculo.resultadoDespesaPessoalManutencao?.despesasGovernoMunicipal ?? 0,
                  dadosFinanceiros[1].vlrDadoFinanceiro
                )
              )
            }}
          </td>
          <td>
            {{
              porcentagemDoValor(
                calcularComplementacao(
                  memoriaDeCalculo.resultadoDespesaPessoalManutencao?.despesasGovernoMunicipal ?? 0,
                  dadosFinanceiros[1].vlrDadoFinanceiro
                ),
                dadosFinanceiros[1].vlrDadoFinanceiro
              )

            }}
          </td>
        </tr>
        <tr class="bold">
          <td>Total</td>
          <td>
            {{ formatarDinheiro(dadosFinanceiros[1].vlrDadoFinanceiro) }}
          </td>
          <td>
            {{ formatarDinheiro(dadosFinanceiros[0].vlrDadoFinanceiro) }}
          </td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoDespesaPessoalManutencao?.despesasGovernoMunicipal ?? 0) }}
          </td>
          <td>
            {{
              formatarDinheiro(
                calcularComplementacao(
                  memoriaDeCalculo.resultadoDespesaPessoalManutencao?.despesasGovernoMunicipal ?? 0,
                  dadosFinanceiros[1].vlrDadoFinanceiro
                )
              )
            }}
          </td>
          <td></td>
        </tr>
      </ng-container>
    </app-tabela>
    <div class="notas">
      <small>
        <em>
          <p>Notas:</p>
          <p>
            <sup>(3)</sup>
             Receita Potencial mínima Vinculada à Educação
             resultantes da vinculação de impostos, transferências do Fundeb e
             Salário Educação.
          </p>
          <p>
            <sup>(4)</sup>
            Resultado das Despesas liquidadas com Educação Básica. Calculada a
            partir dos dados analíticos do SIOPE e dos microdados do FINBRA.
          </p>
          <p>
            <sup>(5)</sup>
            Complementação (R$) - Calculada a partir da diferença
            entre a Projeção da despesa necessária e a receita
            potencial mínima vinculada em cada ente federativo.
          </p>
          <p>
             <sup>(6)</sup>
             Complementação % = [Projeção da despesa necessária / pela
             Receita Potencial mínima Vinculada à Educação] - 1.
          </p>
        </em>
      </small>
    </div>
  </div>

  <!-- TABELA 5 - Projeção da despesa de capital (construção de novos prédios) -->
  <div class="table-content" *ngIf="featureFlagService.funcionalidadeHabilitada('novas-salas')">
    <h2 class="text-lg font-semibold text-blue-900 mb-4 px-4">Projeção da despesa de capital (construção de novos prédios)</h2>
    <app-tabela [cabecalhoCustomizado]="true" ngSkipHydration>
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2" style="width: 20%">Esfera Administrativa</th>
          <th class="table-header" rowspan="2" style="width: 20%">Investimento Total (R$)</th>
          <th class="table-header" colspan="2" style="width: 30%">Educação Infantil</th>
          <th class="table-header" colspan="2" style="width: 30%">Ens. Fund. / Médio / EJA</th>
        </tr>
        <tr>
          <th class="table-header">R$</th>
          <th class="table-header">%</th>
          <th class="table-header">R$</th>
          <th class="table-header">%</th>
        </tr>
      </ng-container>
      <ng-container corpo *ngIf="memoriaDeCalculo">
        <tr>
          <td>Governo Estadual</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoEstadual || 0) }}</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual || 0) }}</td>
          <td>{{ porcentagemDoValor((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual || 0), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoEstadual || 1)) }}</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual || 0) }}</td>
          <td>{{ porcentagemDoValor((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual || 0), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoEstadual || 1)) }}</td>
        </tr>
        <tr>
          <td>Governo Municipal</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoMunicipal || 0) }}</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal || 0) }}</td>
          <td>{{ porcentagemDoValor((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal || 0), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoMunicipal || 1)) }}</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal || 0) }}</td>
          <td>{{ porcentagemDoValor((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal || 0), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotalGovernoMunicipal || 1)) }}</td>
        </tr>
        <tr class="bold">
          <td>Total</td>
          <td>{{ formatarDinheiro(memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotal || 0) }}</td>
          <td>{{ formatarDinheiro((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual || 0) + (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal || 0)) }}</td>
          <td>{{ porcentagemDoValor(((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoEstadual || 0) + (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEdInfantilGovernoMunicipal || 0)), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotal || 1)) }}</td>
          <td>{{ formatarDinheiro((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual || 0) + (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal || 0)) }}</td>
          <td>{{ porcentagemDoValor(((memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoEstadual || 0) + (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosEnsFunEnsMedioEjaGovernoMunicipal || 0)), (memoriaDeCalculo.relatorioCaq.projecaoDespesaConstrucaoNovosPrediosTotal || 1)) }}</td>
        </tr>
      </ng-container>
    </app-tabela>
  </div>
  <div class="table-content">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2">Etapa / Modalidade</th>
          <th class="table-header">{{ mostrarRpebAposVaat ? 'Projeção Orçamento da despesa CAQ (R$)' : 'Projeção da despesa necessária (R$)' }}</th>
          <th class="table-header" rowspan="2">%<sup>(7)</sup></th>
        </tr>
        <tr>
          <th class="table-header">2024</th>
        </tr>
      </ng-container>
      <ng-container corpo *ngIf="memoriaDeCalculo">
        <tr>
          <td>Creche</td>
          <td>
            {{ formatarDinheiro(calcularProjecaoDespesaCreche()) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaCreche(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr>
          <td>Pré-Escola</td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.preEscola ?? 0) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaPreEscola(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr>
          <td>Ensino Fundamental - anos iniciais</td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.ensFunAnosIniciais ?? 0) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEFAnosIniciais(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr>
          <td>Ensino Fundamental - anos finais</td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.ensFunAnosFinais ?? 0) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEFAnosFinais(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr>
          <td>Ensino Médio</td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.ensMedio ?? 0) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEM(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr>
          <td>EJA</td>
          <td>
            {{ formatarDinheiro(memoriaDeCalculo.resultadoEtapa1NumerosDeMatriculas?.eja ?? 0) }}
          </td>
          <td class="center">
            {{
              porcentagemDoValor(
                calcularProjecaoDespesaEJA(),
                obterDespesaCorrenteAno()
              )
            }}
          </td>
        </tr>
        <tr class="bold">
          <td>TOTAL</td>
          <td>
            {{ formatarDinheiro(obterDespesaCorrenteAno()) }}
          </td>
          <td></td>
        </tr>
      </ng-container>
    </app-tabela>
    <div class="notas">
      <small>
        <em>
          <p>Notas:</p>
          <p class="red">
            <sup>(7)</sup>
            Porcentagem do orçamento por etapa.
          </p>
        </em>
      </small>
    </div>
    <div class="download-csv">
      <button mat-button color="primary">
        <mat-icon>table_chart</mat-icon>
        Download CSV
      </button>
    </div>
  </div>
  <div class="table-content">
    <app-tabela
      [cabecalhoCustomizado]="true"
      ngSkipHydration
    >
      <ng-container cabecalho>
        <tr>
          <th class="table-header" rowspan="2" style="width: 33%">
            Área de atuação
          </th>
          <th class="table-header" rowspan="2" style="width: 33%">
            Número de funcionarios Atual
          </th>
          <th class="table-header" style="width: 33%">
            Projeção do número necessário de funcionários
          </th>
        </tr>
        <tr>
          <th class="table-header">2024 </th>
        </tr>
      </ng-container>
      <ng-container corpo *ngIf="dadosEstatisticos && memoriaDeCalculo">

        <tr *ngFor="let funcao of memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.funcionariosPorFuncao; let i = index">
          <td>
            {{ funcao.nomeFuncao }}
          </td>
          <td *ngIf="i === 0" [attr.rowspan]="memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.funcionariosPorFuncao.length">

          </td>
          <td>
            {{funcao.quantidade}}
          </td>
        </tr>
        <tr class="bold">
          <td>TOTAL</td>
          <td class="texto-azul">
            {{
              dadosEstatisticos.totalFuncionarios.toLocaleString('pt-BR')
            }}
          </td>
          <td>
            {{
              memoriaDeCalculo.resultadoEtapa18ProjecaoNumeroFuncionarios.total.toLocaleString('pt-BR')
            }}
          </td>
        </tr>
      </ng-container>
    </app-tabela>
    <div class="download-csv">
      <button mat-button color="primary">
        <mat-icon>table_chart</mat-icon>
        Download CSV
      </button>
    </div>
  </div>
  <div class="finalizar">
    <button routerLink="/home" class="finish-button">Finalizar</button>
  </div>
</div>
